<template>
    <v-card class="my-3" color="grey lighten-3">
        <v-card-title
            class="primary text-uppercase white--text pa-2 mb-2 text-subtitle-2"
            >Credit</v-card-title
        >
        <v-card-text>
            <credit-summary
                :search="search.result"
                :mode="mode"
            ></credit-summary>
        </v-card-text>
    </v-card>
</template>
<script>
export default {
    name: "applicant-credit",
    components: {
        CreditSummary: () =>
            import("@components/screen/components/Credit/CreditSummary"),
    },
    props: {
        search: {
            type: Object,
            required: true,
        },
        mode: {
            type: String,
            required: false,
            default: "screen",
        },
    },
    data() {
        return {};
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {},
    updated() {},
    detroyed() {},
    methods: {},
};
</script>

<style scoped>
</style>